import features from '../common/features';

export default function detectAccessibilitySeat(seat) {
  let holdCodes = features.getOption('accessibilitySeats', 'holdCodes');
  let seatTypes = features.getOption('accessibilitySeats', 'seatTypeIds');

  return (
    seat.seat_row.includes('WC') ||
    holdCodes.includes(seat.hc_no) ||
    seatTypes.includes(seat.seat_type)
  );
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/seats/detectAccessibilitySeat.js